import React from 'react';
import { useNavigate } from 'react-router-dom';

const formatRelativeTime = (timestamp) => {
  if (!timestamp) return '';
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const now = new Date();
  const diffMins  = Math.floor((now - date) / 60000);
  const diffHours = Math.floor((now - date) / 3600000);
  const diffDays  = Math.floor((now - date) / 86400000);
  if (diffMins  <  1)  return 'ahora mismo';
  if (diffMins  < 60)  return 'hace unos minutos';
  if (diffHours < 24)  return 'hoy';
  if (diffDays  === 1) return 'ayer';
  if (diffDays  <  7)  return 'esta semana';
  if (diffDays  < 30)  return 'este mes';
  return date.toLocaleDateString('es-ES', {day: 'numeric', month: 'short'});
};

const NotificationItem = ({notification}) => {
  const navigate = useNavigate();
  let message = '';
  let onClick  = undefined;

  if (notification.type === 'follow')  message = `${notification.senderName} te ha seguido`;
  if (notification.type === 'comment') message = `${notification.senderName} comentó tu receta`;
  if (notification.type === 'like')    message = `A ${notification.senderName} le ha gustado tu receta`;
  if (notification.type === 'recetario_compartido') {
    const nombre = notification.recetarioNombre ? `"${notification.recetarioNombre}"` : 'un recetario';
    const rol    = notification.role === 'editor' ? 'como editor' : '';
    message  = `${notification.senderName} te ha compartido el recetario ${nombre}${rol ? ' ' + rol : ''}`;
    onClick  = notification.recetarioId
      ? () => navigate(`/recetario/${notification.recetarioId}`)
      : undefined;
  }

  return (
    <div
      className={`notification-item${onClick ? ' notification-item--link' : ''}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <span className="notification-text">{message}</span>
      <span className="notification-time">{formatRelativeTime(notification.timestamp)}</span>
    </div>
  );
};

export default NotificationItem;
